import { type } from "@/api/arktype";
import { triageRole, triageSource, triageWaitingFor } from "@/api/triage/schema";

const reference = { id: "number.integer > 0", version: "number.integer > 0" } as const;
const note = type("string.trim").to("string >= 3");

export const TodaySchemas = {
	complete: type({
		...reference,
		note,
	}),
	contest: type({
		...reference,
		reason: type("string.trim").to("string >= 5"),
	}),
	wait: type({
		...reference,
		waiting_for: triageWaitingFor,
		note,
		next_review_at: "Date",
	}),
	contact: type({ ...reference, note, next_review_at: "Date" }),
	transfer: type({ ...reference, role: triageRole, note }),
	resume: type({ ...reference, note }),
	history: type({ id: "number.integer > 0" }),
	evidence: type({
		person_id: "number.integer > 0",
		sources: triageSource.array().atMostLength(100),
	}),
};
